module.exports = __webpack_public_path__ + "static/media/Sempione - DK Grey - Bordeaux_Gold.c93f8a4d.jpg";